__webpack_require__.p = "https://salamonitorada.plurall.net/";